import { LessonController, LessonPhases } from './lesson';
import { QuizOverlay } from './quiz/overlay';
import { showXpPopup, flashCard } from './quiz/feedback';
import { getUiSoundPlayer } from './ui-sounds';
import { loadBank, sampleBank } from './content/bank-loader';
import { loadProgress, saveProgress, createFreshProgress, addFactionXP, skillUnlocked } from '../shared/progress';
import { findOrCreateKP, recordAttempt } from '../shared/student-kp';
import { FACTIONS, factionForSubject } from '../shared/factions';
import { SKILL_CATALOG } from '../shared/skills';
import { mountEscapeButton } from './escape-button';
import { isProMode } from './settings';
import type { LearnDoneCallback } from './app';

export async function runChineseLesson(container: HTMLElement, kpId: string, onDone: LearnDoneCallback): Promise<void> {
  let url: string;
  if (kpId === 'chinese.zhuyin.basic') url = '/data/chinese-zhuyin-康軒.json';
  else if (kpId === 'chinese.segment.summary') url = '/data/chinese-segment-康軒.json';
  else if (kpId === 'chinese.phonetic.tone') url = '/data/chinese-phonetic-康軒.json';
  else if (kpId === 'chinese.vocab.usage') url = '/data/chinese-vocab-usage-康軒.json';
  else if (kpId === 'chinese.sentence.pattern') url = '/data/chinese-sentence-康軒.json';
  else if (kpId === 'chinese.comprehension.basic') url = '/data/chinese-read-康軒.json';
  else if (kpId === 'chinese.writing.guided') url = '/data/chinese-write-康軒.json';
  // ── 三上 backport KP (grade: 3.1) ─────────────────────────────────
  else if (kpId === 'chinese.phonetic.tone.up') url = '/data/chinese-zhuyin-review-康軒-三上.json';
  else if (kpId === 'chinese.vocab.daily.up') url = '/data/chinese-vocab-up-康軒.json';
  else if (kpId === 'chinese.sentence.simple.up') url = '/data/chinese-sentence-up-康軒.json';
  else if (kpId === 'chinese.comprehension.short.up') url = '/data/chinese-paragraph-up-康軒.json';
  else if (kpId === 'chinese.writing.fillin.up') url = '/data/chinese-write-up-康軒.json';
  // ── 三下 新增 7 KP (grade: 3.2) ─────────────────────────────────
  else if (kpId === 'chinese.character.radical') url = '/data/chinese-radical-康軒.json';
  else if (kpId === 'chinese.comprehension.explain') url = '/data/chinese-explain-康軒.json';
  else if (kpId === 'chinese.writing.diary') url = '/data/chinese-diary-康軒.json';
  else if (kpId === 'chinese.punctuation.basic') url = '/data/chinese-punctuation-康軒.json';
  else if (kpId === 'chinese.rhetoric.basic') url = '/data/chinese-rhetoric-康軒.json';
  else if (kpId === 'chinese.idiom.basic') url = '/data/chinese-idiom-康軒.json';
  else if (kpId === 'chinese.culture.community') url = '/data/chinese-culture-康軒.json';
  // ── 三下 by-lesson banks (spec #76) ──────────────────────────────
  else if (kpId === 'chinese.l01.xuyuan') url = '/data/chinese-l01-xuyuan-康軒.json';
  else if (kpId === 'chinese.l02.xiayushihou') url = '/data/chinese-l02-xiayushihou-康軒.json';
  else if (kpId === 'chinese.l03.yujianmeiruunainai') url = '/data/chinese-l03-yujianmeiruunainai-康軒.json';
  else if (kpId === 'chinese.l04.gongjiangzhizu') url = '/data/chinese-l04-gongjiangzhizu-康軒.json';
  else if (kpId === 'chinese.l05.xuetianshukai') url = '/data/chinese-l05-xuetianshukai-康軒.json';
  else if (kpId === 'chinese.l06.shenqimima') url = '/data/chinese-l06-shenqimima-康軒.json';
  else if (kpId === 'chinese.l07.youtonghua') url = '/data/chinese-l07-youtonghua-康軒.json';
  // ── 三下 by-lesson banks L08-L12 (spec #82) ──────────────────────
  else if (kpId === 'chinese.l08.daziranmeishuguan') url = '/data/chinese-l08-daziranmeishuguan-康軒.json';
  else if (kpId === 'chinese.l09.taiwandeshanjiaoyu') url = '/data/chinese-l09-taiwandeshanjiaoyu-康軒.json';
  else if (kpId === 'chinese.l10.yufuhejinyu') url = '/data/chinese-l10-yufuhejinyu-康軒.json';
  else if (kpId === 'chinese.l11.congmingdeshulu') url = '/data/chinese-l11-congmingdeshulu-康軒.json';
  else if (kpId === 'chinese.l12.haiyaodiejici') url = '/data/chinese-l12-haiyaodiejici-康軒.json';
  // ── stage6 wire: meow911 段考真題池(對齊既有 chapter)─────────────
  else if (kpId === 'chinese.l01.xuyuan.meow911') url = '/data/meow911-chinese-ch13-l01-xuyuan.json';
  else if (kpId === 'chinese.l02.xiayushihou.meow911') url = '/data/meow911-chinese-ch14-l02-xiayushihou.json';
  else if (kpId === 'chinese.l03.yujianmeiruunainai.meow911') url = '/data/meow911-chinese-ch15-l03-yujianmeiruunainai.json';
  else if (kpId === 'chinese.l04.gongjiangzhizu.meow911') url = '/data/meow911-chinese-ch16-l04-gongjiangzhizu.json';
  else if (kpId === 'chinese.l07.youtonghua.meow911') url = '/data/meow911-chinese-ch19-l07-youtonghua.json';
  else if (kpId === 'chinese.character.radical.meow911') url = '/data/meow911-chinese-ch2-radical.json';
  else if (kpId === 'chinese.sentence.pattern.meow911') url = '/data/meow911-chinese-ch3-sentence.json';
  else if (kpId === 'chinese.comprehension.basic.meow911') url = '/data/meow911-chinese-ch4-comprehension.json';
  else if (kpId === 'chinese.writing.guided.meow911') url = '/data/meow911-chinese-ch5-writing.json';
  else if (kpId === 'chinese.punctuation.basic.meow911') url = '/data/meow911-chinese-ch6-punctuation.json';
  else if (kpId === 'chinese.meow911.misc') url = '/data/meow911-chinese-misc-pool.json';
  else throw new Error(`Unknown chinese KP: ${kpId}`);

  const bank = await loadBank(url);
  // Sample 10 questions, distinct surfaceVariants. Split: 2 warmup + 3 guide + 5 challenge
  const sampled = sampleBank(bank, 10);
  const phases: LessonPhases = {
    warmup: sampled.slice(0, 2),
    guide: sampled.slice(2, 5),
    challenge: sampled.slice(5, 10),
  };

  // Load (or create) progress early so we can record KP attempts during the lesson
  let progress = loadProgress();
  if (!progress) progress = createFreshProgress('指揮官');
  // v24 教學專業模式 — boss directive 2026-05-22: 教學要專業.
  // 預設 ON ⇒ skip SFX / flashCard / XP popup. Toggle via 設定 → 📚 教學介面.
  const pro = isProMode(progress);
  const kp = findOrCreateKP(progress, kpId, 'chinese');

  const lesson = new LessonController(phases, 2, (correct) => {
    recordAttempt(kp, correct ? 'correct' : 'wrong', new Date().toISOString());
    saveProgress(progress!);
  }); // medium difficulty

  let overlay: QuizOverlay | null = new QuizOverlay({
    container,
    proMode: pro,
    onAnswer: (answer: number | string) => {
      const card = container.querySelector('.card') as HTMLElement | null;
      const result = lesson.submitAnswer(answer);
      if (!pro && card) flashCard(card, result.correct ? 'correct' : 'wrong');
      if (result.correct) {
        if (!pro) getUiSoundPlayer().play('answer-correct', 0.5);
      } else {
        if (!pro) getUiSoundPlayer().play('answer-wrong', 0.4);
      }
      if (!pro) {
        if (result.xp > 0) {
          const faction = FACTIONS[factionForSubject('chinese')];
          getUiSoundPlayer().play('xp-popup', 0.35);
          showXpPopup(`+${Math.round(result.xp)} ${faction.emoji}`, '#ce93d8');
        } else if (!result.correct) {
          showXpPopup('沒關係 +2', '#80cbc4');
        }
      }
      setTimeout(() => {
        if (lesson.state === 'done') finish();
        else renderCurrent();
      }, result.correct ? 500 : 900);
    },
  });

  const unmountEscape = mountEscapeButton(() => {
    overlay?.destroy();
    overlay = null;
    unmountEscape();
    onDone({ newUnlocks: [], exited: true });
  });

  function renderCurrent(): void {
    if (!overlay) return;
    overlay.render(lesson.currentQuestion(), lesson.state, lesson.positionInPhase());
  }

  function finish(): void {
    unmountEscape();
    overlay?.destroy();
    overlay = null;
    // Reuse the progress object already held in closure (has KP updates from recordKP callbacks)
    const faction = factionForSubject('chinese');
    const xp = Math.round(lesson.totalXP);
    addFactionXP(progress!, faction, xp);
    // Same generic unlock detection as math lesson
    const newUnlocks: string[] = [];
    for (const skill of SKILL_CATALOG) {
      if (skill.faction === 'builtin') continue;
      if (skillUnlocked(progress!, skill.id)) continue;
      if (progress!.factionXP[skill.faction] >= skill.cost) {
        progress!.unlockedSkills.push(skill.id);
        newUnlocks.push(skill.id);
      }
    }
    saveProgress(progress!);
    onDone({ newUnlocks });
  }

  renderCurrent();
}

/** Backward-compat shim — callers that still use the old name continue to work. */
export async function runChineseZhuyinLesson(container: HTMLElement, onDone: LearnDoneCallback): Promise<void> {
  return runChineseLesson(container, 'chinese.zhuyin.basic', onDone);
}
